<mat-sidenav-container color="primary">
    <mat-sidenav-content>
        <div fxLayout="column"  class="mat-elevation-z1">
        <!-- <div style="margin-left: 30px;margin-right: 30px;" fxLayout="column"  class="mat-elevation-z1"> -->
            <div>
                <mat-toolbar style="margin-top: 10px;" color="primary">
                    <mat-toolbar-row>
                        <h2 style="margin-left: 39%;">Personal Details</h2>
                        <button type="submit" mat-button [disabled]="personalDetailsDataEntryForm.invalid" (click)="saveConfirmation()" [ngClass]="{ 'custom-button': true, 'disabled': (personalDetailsDataEntryForm.invalid)}"> Save </button>
                    </mat-toolbar-row>
                </mat-toolbar>
            </div>
            <div style="margin-top: 10px;" fxFlex="100%">
                <div style="display: flex; margin-bottom: 10px;margin-left: 10px;" *ngIf="statusInDb == 'CDE-REJECTED'">
                    <label style="margin-right: 10px;">Rejection Remarks : </label>
                    <textarea style="color:red; font-size: large; width:50%" readonly matInput cols="10" rows="1"
                    [(ngModel)]="inputqcComments" placeholder="Rejection Remarks"></textarea>
                </div>

                <form [formGroup]="personalDetailsDataEntryForm">
                    <mat-grid-list cols="3" rowHeight="70px">
                        <mat-grid-tile *ngFor="let personalDetailsField of personalDetailsFields">
                            <mat-form-field style="width:95%;margin-top: 15px;"  *ngIf="personalDetailsField.type=='TEXT'" appearance="outline" >
                              <div *ngIf="personalDetailsField.value; else default">
                                <input *ngIf="personalDetailsField.value; else default"  formControlName="{{personalDetailsField.name}}" required="{{personalDetailsField.mandatory}}" matInput size="30" [attr.maxlength]="getFieldSize(personalDetailsField)" type="text"  ngDefaultControl [(ngModel)]="personalDetailsField.value" placeholder={{personalDetailsField.label}}>
                              </div>
                              <ng-template #default>
                                <input #default formControlName="{{personalDetailsField.name}}" required="{{personalDetailsField.mandatory}}" matInput size="30" [attr.maxlength]="getFieldSize(personalDetailsField)" type="text"  placeholder={{personalDetailsField.label}}>
                              </ng-template>
                                <mat-label>{{personalDetailsField.label}}</mat-label>
                            </mat-form-field> 
 

                            <mat-form-field style="width:95%;margin: 10px 0px -14px 0px;"  *ngIf="personalDetailsField.type=='DATE'" appearance="outline">
                              <div *ngIf="personalDetailsField.value; else datedefault">
                                <input formControlName={{personalDetailsField.name}} required="{{personalDetailsField.mandatory}}" matInput size="11" maxlength="11" type="date" ngDefaultControl [(ngModel)]="personalDetailsField.value" placeholder={{personalDetailsField.label}}>
                              </div>
                              <ng-template #datedefault>
                                <input formControlName={{personalDetailsField.name}} required="{{personalDetailsField.mandatory}}" matInput size="11" maxlength="11" type="date"  placeholder={{personalDetailsField.label}}>
                              </ng-template>
                                <mat-label>{{personalDetailsField.label}}</mat-label>
                            </mat-form-field>

                        </mat-grid-tile>
                        
                    </mat-grid-list>

                   <!-- <button type="submit"  mat-raised-button color="primary" style="color: white; width: 55px; height: 36px; border-radius: 9px; margin-bottom: 3px; text-align: center; position: absolute; right: 47px; top: 259px; " [disabled]="personalDetailsDataEntryForm.invalid" matTooltip="Save Personal Details" mat-icon-button (click)="saveConfirmation()"> Save </button> -->

                </form>
            </div>
            <div *ngIf="statusInDb == 'CDE-REJECTED'">
                <mat-form-field appearance="outline">
                    <textarea readonly matInput cols="30" rows="3" [(ngModel)]="inputqcComments" placeholder="Rejection Remarks"></textarea>
                    <mat-label>Rejection Remarks</mat-label>
                </mat-form-field>
           </div>
        </div>

    </mat-sidenav-content>
</mat-sidenav-container>
